module.exports = __webpack_public_path__ + "src/assets/img/share/tips/conscientiousness/3c18d7853d16bf8281805b255b5140a6.png";